export const environment = {
  production: false,
  authority: 'https://sso-authorization-api-cdt.maersk.io',
  clientId: '9NkFZsxwvpc1OuoR8apg9cZqrX-UkBqZj6japnE2ygk',
  redirectPath: '/callback',
  scope: 'openid profile email',
  hintEndpoint: '/hint'
}
